<template>
    <div class="pagination">
        <button
                v-if="currentChunk"
                @click="currentChunk--"
                class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect "
        >
            <i class="material-icons">arrow_back</i>
        </button>
        <button
                v-for="(page, key) in pageChunks[currentChunk]"
                :key="key"
                v-text="page"
                @click.prevent="updatePage(page, searchTerm)"
                class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect"
                :class="{ 'button--colored-gradient-primary': pagination.currentPage === page }"
        >
        </button>
        <button
                v-if="currentChunk < pageChunks.length - 1"
                v-text="'...'"
                @click="currentChunk++"
                class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect"
        >
        </button>
        <button
                v-text="pagination.totalPages"
                @click.prevent="setLastPage(searchTerm)"
                class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect"
                :class="{ 'button--colored-gradient-primary': pagination.currentPage === pagination.totalPages }"
        >
        </button>
    </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true
    },
    searchTerm: {
      type: String,
      required: false
    }
  },
  data: () => ({
    currentChunk: 0
  }),
  computed: {
    pageChunks () {
      let pages = []
      let chunks = []

      for (let i = 1; i < this.pagination.totalPages; i++) {
        pages.push(i)
      }

      for (let i = 0; i < pages.length; i + 4) {
        let slice = pages.slice(0, 4)
        chunks.push(slice)
        pages.splice(0, 4)
      }

      return chunks
    }
  },
  mounted () {
    if (this.pageChunks && this.pageChunks.length) {
      if (this.pagination.currentPage === this.pagination.totalPages) {
        this.currentChunk = this.pageChunks.length - 1
      } else {
        for (let i = 0; i < this.pageChunks.length; i++) {
          let chunk = this.pageChunks[i]

          if (chunk === this.pagination.currentPage) {
            this.currentChunk = i
            break
          }
        }
      }
    }
  },
  methods: {
    updatePage (page, searchTerm) {
      this.$emit('changePage', page, searchTerm)
    },
    setLastPage (searchTerm) {
      this.$emit('changePage', this.pagination.totalPages, searchTerm)
      this.currentChunk = this.pageChunks.length - 1
    }
  }
}
</script>
